import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n/config";
import "./lib/console-guard";

// Manifest swap is handled by inline script in index.html (before modules load)

// Redirect www to non-www
if (window.location.hostname.startsWith("www.")) {
  window.location.replace(
    window.location.href.replace("://www.", "://")
  );
} else {
  createRoot(document.getElementById("root")!).render(<App />);
}
